export default __webpack_public_path__ + "static/media/CNo.58-6.b3a05959.jpg";